/*eslint-disable no-undef*/
// Must be the first import
if (process.env.NODE_ENV !== 'production') {
  // Must use require here as import statements are only allowed
  // to exist at the top of a file.
  require('preact/debug');
}

require('grpn-ls-polyfills/lib/polyfills-prod');
require('core/frontend/vendor/jquery');
require('core/frontend/vendor/underscore');
require('core/frontend/vendor/modernizr');
require('core/frontend/vendor/hogan');
require('src/frontend/vendor/eventPause-custom');
require('jquery.finger');

require('src/frontend/old/groupon_modules/groupon');
require('./chunks/critical_path');

const responsiveMenu = require('../../gig_body/header/v6.0/responsive_menu/frontend/responsive_menu');
const { windowLoaded } = require('@grpn/document-states');

require('./desktop-misc');

/*eslint-disable no-undef*/
windowLoaded.then(() => {
  __webpack_public_path__ = window.remoteUrl;
  import(/* webpackChunkName: 'desktop-preact' */ './chunks/desktop-preact');
});

windowLoaded.then(() => {
  Groupon.LS.responsiveMenu = () => new responsiveMenu();

  // When < 600px (mobile), change the viewport meta tag to disable user scaling.
  // This prevents unnecessary zooming when focusing on inputs and is an alternative to
  // setting the font size of the inputs to 16px (which Apple recommends for iOS Safari).
  const { mMax } = Groupon.LS.mediaQueries;
  if (Groupon.LS.hasTouch && matchMedia(mMax).matches) {
    const meta = document.head.querySelector('meta[name=viewport]');
    if (meta) {
      meta.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
      );
    }
  }
});
